import mixpanel from 'mixpanel-browser';

var trackingUtils = (function () {
  let isIntialized = false;

  // initializes mixpanel
  var initializeTracking = () => {
    if (!isIntialized) {
      const record_sessions_percent =
        process.env.MIXPANEL_RECORD_SESSIONS_PERCENT || 15;
      mixpanel.init(process.env.MIXPANEL_TOKEN, {
        property_blacklist: [
          '$device',
          '$device_id',
          '$anon_distinct_id',
          '$current_url',
          '$initial_referrer',
          '$initial_referring_domain',
          'mp_lib',
          '$referrer',
          '$referring_domain',
          '$search_engine',
          'mp_keyword',
          '$lib_version'
        ],
        ignore_dnt: true,
        disable_persistence: true,
        record_sessions_percent,
        record_heatmap_data: true,
        record_mask_text_selector: "input[type='password']"
      });

      isIntialized = true;
    } else {
      console.warn('Mixpanel has already been initialized.');
    }
  };

  // sets distinct_id and user_id
  var identify = () => {
    if (!isIntialized) return;
    try {
      const currentUser = JSON.parse(localStorage.getItem('current-user'));
      const company = JSON.parse(localStorage.getItem('company'));
      mixpanel.identify(currentUser?.id || '');
    } catch (err) {
      console.error(err);
    }
  };

  // sets user profile properties
  var setProperty = () => {
    if (!isIntialized) return;
    try {
      const currentUser = JSON.parse(localStorage.getItem('current-user'));
      const company = JSON.parse(localStorage.getItem('company'));
      mixpanel.people.set({
        $name: `${currentUser?.firstName || ''} ${currentUser?.lastName || ''}`,
        company_id: currentUser?.companyId || '',
        company_name: company?.name || '',
        email_id: currentUser?.email || ''
      });
    } catch (err) {
      console.error(err);
    }
  };

  // tracks event
  var track = (actionName) => {
    if (!isIntialized) return;
    try {
      mixpanel.track(actionName);
    } catch (err) {
      console.error(err);
    }
  };

  return {
    initializeTracking,
    track,
    identify,
    setProperty
  };
})();

var isMixPanelTrackingEnabled = () => {
  if (process.env.APP_ENV === 'demo' || process.env.APP_ENV === 'production') {
    return true;
  }
  return false;
};

export { isMixPanelTrackingEnabled, trackingUtils };
